import Vue from 'vue';
import VueRouter from 'vue-router';

import multiguard from 'vue-router-multiguard';
import PlatformGuard from './platformGuard';
import LoginGuard from './loginGuard';
import frontstageLiffGuard from './frontstageLiffGuard';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/userlogin/index'),
    beforeEnter: multiguard([PlatformGuard]),
    meta: {
      title: '會員登入',
      allowPlatform: ['liffApp', 'web'],
    },
  },
  {
    path: '/userhome',
    name: 'userhome',
    component: () => import('@/views/userhome/index'),
    beforeEnter: multiguard([PlatformGuard, frontstageLiffGuard]),
    meta: {
      title: '會員作品',
      allowPlatform: ['liffApp', 'web'],
    },
  },
  {
    path: '/housedetail',
    name: 'housedetail',
    component: () => import('@/views/housedetail/index'),
    beforeEnter: multiguard([PlatformGuard, frontstageLiffGuard]),
    meta: {
      title: '階段繳款',
      allowPlatform: ['liffApp', 'web'],
    },
  },
  {
    path: '/management',
    name: 'management',
    component: () => import('@/views/login/index'),
    beforeEnter: multiguard([PlatformGuard]),
    meta: {
      title: '後台管理',
      allowPlatform: ['liffApp', 'web'],
    },
  },
  {
    path: '/onlinereserve',
    name: 'onlinereserve',
    component: () => import('@/views/contactus/index'),
    beforeEnter: multiguard([PlatformGuard]),
    meta: {
      title: '預約簡報',
      allowPlatform: ['liffApp', 'web'],
    },
  },
  {
    path: '/',
    component: () => import('@/views/home/index'),
    children: [
      {
        path: '/',
        name: 'home',
        redirect: '/login',
      },
      {
        path: '/invoice',
        name: 'invoice',
        component: () => import('@/views/invoice/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '發票管理',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/addbuilding',
        name: 'addbuilding',
        component: () => import('@/views/addbuilding/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '新增作品',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/tags',
        name: 'tags',
        component: () => import('@/views/tags/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '身份別管理',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/tags/:id',
        name: 'tags-member',
        component: () => import('@/views/tags/members/index'),
        props: true,
        meta: {
          title: '身份別管理',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/members',
        name: 'members',
        component: () => import('@/views/members/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '德築關係人總表',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/members/add',
        name: 'members-add',
        component: () => import('@/views/members/edit/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '新增德築關係人',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/members/:id',
        name: 'members-edit',
        component: () => import('@/views/members/edit/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '編輯德築關係人',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/appointment',
        name: 'appointment',
        component: () => import('@/views/appointment/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '群發訊息',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/flexMessage',
        name: 'flexMessage',
        component: () => import('@/views/flexMessage/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '關鍵字自動回應訊息',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/myhouse',
        name: 'myhouse',
        component: () => import('@/views/myhouseOrder/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: 'MyHouse訂單',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/inform',
        name: 'inform',
        component: () => import('@/views/inform/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '訊息通知管理',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/brief',
        name: 'brief',
        component: () => import('@/views/brief/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '預約簡報',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/editor',
        name: 'editor',
        component: () => import('@/views/editor/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '小編設定',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/systemUsers',
        name: 'systemUsers',
        component: () => import('@/views/systemUsers/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '管理者設定',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/baseset/:bid',
        name: 'baseset',
        component: () => import('@/views/baseset/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '基本設定',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/color',
        name: 'color',
        component: () => import('@/views/color/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '建案單元/顏色',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/buildlist',
        name: 'buildlist',
        component: () => import('@/views/buildlist/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '建案清單',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/sales',
        name: 'sales',
        component: () => import('@/views/sales/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '銷售管理',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/parking/:bid',
        name: 'parking',
        component: () => import('@/views/parking/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '車位設定',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/parking/:bid/add',
        name: 'parking-add',
        component: () => import('@/views/parking/add/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '新增車位',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/parking/:bid/edit/:id',
        name: 'parking-edit',
        component: () => import('@/views/parking/edit/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '車位設定',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/household/:bid',
        name: 'household',
        component: () => import('@/views/household/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '戶別管理',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/household/:bid/add',
        name: 'household-add',
        component: () => import('@/views/household/add/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '戶別管理',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/household/:bid/edit/:id',
        name: 'household-edit',
        component: () => import('@/views/household/edit/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '戶別管理',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/contract/:bid',
        name: 'contract',
        component: () => import('@/views/contract/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '契約管理',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/contract/:bid/add',
        name: 'contract-add',
        component: () => import('@/views/contract/add/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '契約管理',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/contract/:bid/edit/:id',
        name: 'contract-edit',
        component: () => import('@/views/contract/edit/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '契約管理',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/contract/:bid/schedule/:id',
        name: 'contract-schedule',
        component: () => import('@/views/contract/schedule/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '契約管理',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/contractowner/:bid',
        name: 'contractowner',
        component: () => import('@/views/contractowner/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '我是屋主',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/contractowner/schedule/:bid/:id',
        name: 'contractowner-schedule',
        component: () => import('@/views/contractowner/schedule/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '我是屋主',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/vendor/:bid',
        name: 'vendor',
        component: () => import('@/views/vendor/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '廠商電話',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/worktags',
        name: 'worktags',
        component: () => import('@/views/worktags/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '工種標籤',
          allowPlatform: ['liffApp', 'web'],
        },
      },
      {
        path: '/cpitems',
        name: 'cpitems',
        component: () => import('@/views/contractpaymentitems/index'),
        beforeEnter: multiguard([PlatformGuard, LoginGuard]),
        props: true,
        meta: {
          title: '繳款品項',
          allowPlatform: ['liffApp', 'web'],
        },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
router.beforeResolve((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;
